import Api from './api';

const ContasEducacaoService = {
    listarReceitas: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/receitaeducacao/listar',
            params: params
        })
        return response
    },
    buscarReceitas: (params) => {
        const response = Api.get(`/receitaeducacao/buscar?${params}`)
        return response
    },
    listarDespesas: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/despesaeducacao/listar',
            params: params
        })
        return response
    },
    buscarDespesas: (params) => {
        const response = Api.get(`/despesaeducacao/buscar?${params}`)
        return response
    }
}

export default ContasEducacaoService;